import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Details from "./pages/Details";
import Home from "./pages/Home";

function App() {
    return (
        <BrowserRouter>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/blogs/:id" element={<Details />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
